import { APIHandler, EventSourceHandler } from "../../base";

export const fetchTenants = (search?: string) =>
    APIHandler.get(`/admin/tenants${search ? `?search=${encodeURIComponent(search)}` : ""}`);

export const createTenant = (data: { name: string; displayName: string; subdomain: string }) =>
    APIHandler.post("/admin/tenants", data);

export const deleteTenant = (companyId: number) => APIHandler.delete(`/admin/tenants/${companyId}`);

export const fetchAdminInviteLink = (companyId: number) =>
    APIHandler.get(`/admin/tenants/${companyId}/admin-invite`);

export const fetchTenantLicensing = (companyId: number) =>
    APIHandler.get(`/admin/tenants/${companyId}/licensing`);

export const updateTenantLicensing = (
    companyId: number,
    data: { enabled: boolean; startDate: string | null; limit: number | null }
) => APIHandler.patch(`/admin/tenants/${companyId}/licensing`, data);

export const fetchPermissionsCatalog = () => APIHandler.get("/admin/tenants/permissions-catalog");

export const updateTenantPermissions = (
    companyId: number,
    permissions: Record<string, boolean> | null
) => APIHandler.patch(`/admin/tenants/${companyId}/permissions`, { permissions });

export const subscribeTenantUpdates = () => EventSourceHandler("/admin/tenants/sse");
